module.exports = __webpack_public_path__ + "img/w3_bookmark_square_black.030d5063.png";